import { NewsArticle } from '../types';

export const newsArticles: NewsArticle[] = [
  // ===== TEXTIL =====
  // Noticias técnicas - Textil
  {
    id: 'textil-tecnica-1',
    title: 'Desarrollo de nuevos materiales textiles sustentables',
    excerpt: 'Investigadores argentinos desarrollan fibras textiles biodegradables y eco-friendly.',
    content: 'Científicos del INTI y universidades argentinas están desarrollando nuevos materiales textiles sustentables. Estos avances incluyen fibras de bambú, cáñamo y algodón orgánico que reducen significativamente el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Industria Textil Hoy',
    publishedDate: '2024-01-22',
    author: 'Carlos Mendoza',
    tags: ['materiales sustentables', 'investigación', 'fibras naturales'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.industriatextilhoy.com.ar/desarrollo-materiales-textiles-sustentables'
  },
  {
    id: 'textil-tecnica-2',
    title: 'Implementación de impresión 3D en la industria textil argentina',
    excerpt: 'Empresas textiles adoptan tecnologías de impresión 3D para crear diseños únicos.',
    content: 'La industria textil argentina está adoptando tecnologías de impresión 3D para crear diseños únicos y personalizados. Estas tecnologías permiten imprimir directamente sobre telas, creando patrones complejos y texturas innovadoras.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Tecnología Textil',
    publishedDate: '2024-01-24',
    author: 'Ing. Ana Martínez',
    tags: ['impresión 3D', 'diseño textil', 'innovación'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.tecnologiatextil.com.ar/implementacion-impresion-3d-industria-textil-argentina'
  },
  {
    id: 'textil-tecnica-3',
    title: 'Nuevos procesos de teñido sin agua para la industria textil',
    excerpt: 'Empresas argentinas implementan técnicas de teñido que reducen el consumo de agua.',
    content: 'Empresas textiles argentinas están implementando nuevos procesos de teñido que reducen significativamente el consumo de agua. Estas técnicas incluyen teñido con CO2 supercrítico y tecnologías de teñido digital que minimizan el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Textil Sustentable',
    publishedDate: '2024-01-26',
    author: 'María González',
    tags: ['teñido sin agua', 'sustentabilidad', 'reducción consumo'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.textilsustentable.com.ar/nuevos-procesos-tenido-sin-agua-industria-textil'
  },
  // Noticias de color - Textil
  {
    id: 'textil-color-1',
    title: 'Fábrica histórica de Buenos Aires se convierte en centro cultural',
    excerpt: 'Una antigua fábrica textil del barrio de San Telmo será transformada en un espacio cultural y gastronómico.',
    content: 'La histórica fábrica textil ubicada en San Telmo, Buenos Aires, será restaurada y convertida en un moderno centro cultural. El proyecto incluirá restaurantes, galerías de arte y espacios para eventos culturales.',
    image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Cultura Porteña',
    publishedDate: '2024-01-19',
    author: 'María López',
    tags: ['patrimonio', 'cultura', 'renovación urbana'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.culturaportena.com/fabrica-historica-san-telmo-centro-cultural'
  },
  {
    id: 'textil-color-2',
    title: 'Diseñadora argentina gana concurso internacional de moda sustentable',
    excerpt: 'Valentina Rossi recibió el premio "Sustainable Fashion Award" en París.',
    content: 'Valentina Rossi, diseñadora argentina de 28 años, recibió el prestigioso premio "Sustainable Fashion Award" en la Semana de la Moda de París. Su colección utiliza únicamente materiales reciclados y técnicas de producción sustentables.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Moda Argentina',
    publishedDate: '2024-01-21',
    author: 'Sofía Rodríguez',
    tags: ['moda sustentable', 'premios', 'diseño'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.modaargentina.com/valentina-rossi-premio-sustainable-fashion-award-paris'
  },
  {
    id: 'textil-color-3',
    title: 'Ex trabajador textil crea marca de ropa para personas con discapacidad',
    excerpt: 'Miguel Ángel López desarrolla ropa adaptada para personas con movilidad reducida.',
    content: 'Miguel Ángel López, ex trabajador de una fábrica textil de Rosario, ha creado una marca de ropa especializada para personas con discapacidad. Sus diseños incluyen cierres magnéticos, velcros estratégicos y telas especiales para mayor comodidad.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'textil',
    source: 'Inclusión y Moda',
    publishedDate: '2024-01-23',
    author: 'Diego Morales',
    tags: ['inclusión', 'ropa adaptada', 'discapacidad'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.inclusionymoda.com/miguel-angel-lopez-ropa-adaptada-discapacidad'
  },

  // ===== MUEBLES & DECO =====
  // Noticias técnicas - Muebles & Deco
  {
    id: 'muebles-tecnica-1',
    title: 'Innovaciones en materiales sustentables para muebles argentinos',
    excerpt: 'Empresas argentinas adoptan materiales eco-friendly para la fabricación de muebles.',
    content: 'La industria del mueble en Argentina está revolucionando sus procesos con la adopción de materiales sustentables. Empresas líderes están utilizando maderas certificadas FSC, adhesivos sin formaldehído y acabados a base de agua para reducir el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Industria del Mueble',
    publishedDate: '2024-01-25',
    author: 'Roberto Silva',
    tags: ['materiales sustentables', 'muebles', 'certificación FSC'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.industriadelmueble.com.ar/innovaciones-materiales-sustentables-muebles-argentinos'
  },
  {
    id: 'muebles-tecnica-2',
    title: 'Implementación de CNC en la fabricación de muebles personalizados',
    excerpt: 'Tecnología CNC revoluciona la producción de muebles a medida en Argentina.',
    content: 'Las empresas de muebles argentinas están adoptando tecnología CNC (Control Numérico Computarizado) para la fabricación de muebles personalizados. Esta tecnología permite mayor precisión, reducción de desperdicios y tiempos de producción más cortos.',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Tecnología del Mueble',
    publishedDate: '2024-01-27',
    author: 'Ing. Ana Martínez',
    tags: ['CNC', 'muebles personalizados', 'tecnología'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.tecnologiadelmueble.com.ar/implementacion-cnc-fabricacion-muebles-personalizados'
  },
  {
    id: 'muebles-tecnica-3',
    title: 'Desarrollo de muebles inteligentes con IoT integrado',
    excerpt: 'Investigadores argentinos crean muebles con tecnología IoT para hogares inteligentes.',
    content: 'Científicos argentinos están desarrollando muebles inteligentes con tecnología IoT integrada. Estos muebles incluyen sensores de movimiento, iluminación automática y conectividad WiFi para crear hogares más inteligentes y eficientes.',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Muebles Inteligentes',
    publishedDate: '2024-01-29',
    author: 'Dr. Carlos Mendoza',
    tags: ['IoT', 'muebles inteligentes', 'hogar inteligente'],
    isTechnical: true,
    readTime: 6,
    url: 'https://www.mueblesinteligentes.com.ar/desarrollo-muebles-inteligentes-iot-integrado'
  },
  // Noticias de color - Muebles & Deco
  {
    id: 'muebles-color-1',
    title: 'Diseñador argentino gana premio internacional de diseño de muebles',
    excerpt: 'Juan Carlos Pérez recibió el "Furniture Design Award" en Milán por su colección sustentable.',
    content: 'Juan Carlos Pérez, diseñador argentino de 32 años, recibió el prestigioso "Furniture Design Award" en la Feria del Mueble de Milán. Su colección "Eco-Home" utiliza materiales reciclados y técnicas de producción sustentables.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Diseño Argentino',
    publishedDate: '2024-01-26',
    author: 'Laura Fernández',
    tags: ['diseño', 'premios', 'muebles sustentables'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.disenoargentino.com/juan-carlos-perez-premio-furniture-design-milan'
  },
  {
    id: 'muebles-color-2',
    title: 'Famosa influencer de decoración lanza línea de muebles en Argentina',
    excerpt: 'María "La Decoradora" González presenta su colección de muebles en Buenos Aires.',
    content: 'María González, conocida como "La Decoradora" en redes sociales, ha lanzado su propia línea de muebles en Argentina. La colección incluye 50 piezas únicas inspiradas en el estilo de vida argentino y la cultura local.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Influencers y Negocios',
    publishedDate: '2024-01-28',
    author: 'Sofía Rodríguez',
    tags: ['influencer', 'decoración', 'emprendimiento'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.influencersynegocios.com/maria-decoradora-linea-muebles-argentina'
  },
  {
    id: 'muebles-color-3',
    title: 'Ex carpintero crea taller de muebles para personas con movilidad reducida',
    excerpt: 'Carlos "El Carpintero" Rodríguez adapta muebles para mejorar la accesibilidad.',
    content: 'Carlos Rodríguez, ex carpintero de 45 años, ha creado un taller especializado en muebles adaptados para personas con movilidad reducida. Sus diseños incluyen mesas ajustables, sillas ergonómicas y muebles con agarres especiales.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'muebles',
    source: 'Inclusión y Diseño',
    publishedDate: '2024-01-30',
    author: 'Diego Morales',
    tags: ['inclusión', 'muebles adaptados', 'accesibilidad'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.inclusionydiseno.com/carlos-carpintero-muebles-movilidad-reducida'
  },

  // ===== HERRERÍAS =====
  // Noticias técnicas - Herrerías
  {
    id: 'herrerias-tecnica-1',
    title: 'Avances en automatización industrial para el sector metalúrgico',
    excerpt: 'Empresas argentinas implementan sistemas de automatización avanzados para mejorar la productividad.',
    content: 'La industria metalúrgica argentina está adoptando tecnologías de automatización de última generación. Empresas como Siderar y Acindar están implementando sistemas de control inteligente que permiten una producción más eficiente y segura.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Industria Metalúrgica',
    publishedDate: '2024-01-18',
    author: 'Roberto Silva',
    tags: ['automatización', 'productividad', 'tecnología industrial'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.industriametalurgica.com.ar/avances-automatizacion-industrial-sector-metalurgico'
  },
  {
    id: 'herrerias-tecnica-2',
    title: 'Nuevos procesos de fundición con menor impacto ambiental',
    excerpt: 'Tecnologías de fundición verde reducen emisiones de CO2 en la industria metalúrgica argentina.',
    content: 'Empresas metalúrgicas argentinas están implementando nuevos procesos de fundición que reducen significativamente las emisiones de CO2. Estas tecnologías incluyen hornos eléctricos y sistemas de reciclaje de gases que minimizan el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Metalurgia Verde',
    publishedDate: '2024-01-20',
    author: 'Carlos Mendoza',
    tags: ['fundición verde', 'sustentabilidad', 'reducción emisiones'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.metalurgiaverde.com.ar/nuevos-procesos-fundicion-menor-impacto-ambiental'
  },
  {
    id: 'herrerias-tecnica-3',
    title: 'Desarrollo de aleaciones especiales para la industria automotriz',
    excerpt: 'Investigadores argentinos crean nuevas aleaciones de acero para vehículos más ligeros y seguros.',
    content: 'Científicos del INTI y universidades argentinas están desarrollando nuevas aleaciones de acero especiales para la industria automotriz. Estas aleaciones permiten fabricar vehículos más ligeros, seguros y eficientes en el consumo de combustible.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Investigación Metalúrgica',
    publishedDate: '2024-01-22',
    author: 'Dr. Ana Martínez',
    tags: ['aleaciones', 'industria automotriz', 'investigación'],
    isTechnical: true,
    readTime: 6,
    url: 'https://www.investigacionmetalurgica.com.ar/desarrollo-aleaciones-especiales-industria-automotriz'
  },
  // Noticias de color - Herrerías
  {
    id: 'herrerias-color-1',
    title: 'Artesanos metalúrgicos preservan técnicas centenarias',
    excerpt: 'Un grupo de artesanos en La Plata mantiene vivas las técnicas tradicionales de forja y metalurgia.',
    content: 'En La Plata, un grupo de artesanos metalúrgicos está preservando técnicas centenarias de forja y metalurgia. Su taller, que funciona desde hace más de 50 años, es visitado por turistas y estudiantes interesados en aprender estos oficios tradicionales.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Artesanías Argentinas',
    publishedDate: '2024-01-23',
    author: 'Diego Morales',
    tags: ['artesanías', 'tradición', 'oficios'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.artesaniasargentinas.com/artesanos-metalurgicos-tecnicas-centenarias'
  },
  {
    id: 'herrerias-color-2',
    title: 'Escultor metalúrgico crea monumento con chatarra reciclada',
    excerpt: 'El artista plástico Juan Carlos Romero construye una escultura monumental en Rosario.',
    content: 'El reconocido escultor Juan Carlos Romero está creando una monumental escultura en Rosario utilizando únicamente chatarra reciclada de la industria metalúrgica. La obra, de 15 metros de altura, representa la historia industrial de la ciudad.',
    image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Arte y Metalurgia',
    publishedDate: '2024-01-25',
    author: 'María López',
    tags: ['escultura', 'reciclaje', 'arte público'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.arteymetalurgia.com/escultor-metalurgico-crea-monumento-chatarra-reciclada'
  },
  {
    id: 'herrerias-color-3',
    title: 'Ex trabajador metalúrgico se convierte en youtuber de tecnología',
    excerpt: 'Carlos "El Metalúrgico" Rodríguez enseña técnicas de soldadura en redes sociales.',
    content: 'Carlos Rodríguez, ex trabajador de una fábrica metalúrgica de Córdoba, se ha convertido en un exitoso youtuber con más de 500 mil seguidores. Su canal "El Metalúrgico" enseña técnicas de soldadura y metalurgia a jóvenes interesados en el oficio.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'herrerias',
    source: 'Redes y Metalurgia',
    publishedDate: '2024-01-27',
    author: 'Sofía Rodríguez',
    tags: ['youtube', 'educación', 'soldadura'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.redesymetalurgia.com/ex-trabajador-metalurgico-youtuber-tecnologia'
  },

  // ===== GRIFERÍA =====
  // Noticias técnicas - Grifería
  {
    id: 'griferia-tecnica-1',
    title: 'Innovaciones en grifería inteligente para hogares argentinos',
    excerpt: 'Empresas argentinas implementan sistemas de grifería con sensores y control automático.',
    content: 'La industria de la grifería en Argentina está adoptando tecnologías inteligentes que incluyen sensores de movimiento, control de temperatura automático y sistemas de ahorro de agua. Estas innovaciones permiten reducir el consumo de agua hasta en un 40%.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Grifería Inteligente',
    publishedDate: '2024-01-28',
    author: 'Ing. Roberto Silva',
    tags: ['grifería inteligente', 'ahorro de agua', 'sensores'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.griferiainteligente.com.ar/innovaciones-griferia-inteligente-hogares-argentinos'
  },
  {
    id: 'griferia-tecnica-2',
    title: 'Desarrollo de materiales anticorrosivos para grifería',
    excerpt: 'Investigadores argentinos crean nuevos materiales resistentes a la corrosión para grifería.',
    content: 'Científicos del INTI están desarrollando nuevos materiales anticorrosivos para grifería que prolongan la vida útil de los productos. Estos materiales incluyen aleaciones especiales y recubrimientos nanotecnológicos que resisten el agua salada y la humedad.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Materiales Avanzados',
    publishedDate: '2024-01-30',
    author: 'Dr. Ana Martínez',
    tags: ['materiales anticorrosivos', 'investigación', 'nanotecnología'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.materialesavanzados.com.ar/desarrollo-materiales-anticorrosivos-griferia'
  },
  {
    id: 'griferia-tecnica-3',
    title: 'Implementación de estándares de eficiencia hídrica en grifería',
    excerpt: 'Nuevas normativas argentinas establecen estándares de eficiencia para grifería residencial.',
    content: 'El gobierno argentino está implementando nuevas normativas que establecen estándares de eficiencia hídrica para grifería residencial. Estas regulaciones promueven el uso de tecnologías que reducen el consumo de agua sin comprometer la funcionalidad.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Normativas Argentinas',
    publishedDate: '2024-02-01',
    author: 'Carlos Mendoza',
    tags: ['eficiencia hídrica', 'normativas', 'sustentabilidad'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.normativasargentinas.com/implementacion-estandares-eficiencia-hidrica-griferia'
  },
  // Noticias de color - Grifería
  {
    id: 'griferia-color-1',
    title: 'Diseñador argentino gana premio internacional de diseño de grifería',
    excerpt: 'Martín "El Grifero" López recibió el "Plumbing Design Award" en Italia.',
    content: 'Martín López, diseñador argentino especializado en grifería, recibió el prestigioso "Plumbing Design Award" en la Feria de Milán. Su colección "Agua Pura" combina diseño moderno con funcionalidad sustentable.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Diseño y Grifería',
    publishedDate: '2024-01-29',
    author: 'Laura Fernández',
    tags: ['diseño', 'premios', 'grifería sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.disenoygriferia.com/martin-grifero-lopez-premio-plumbing-design-italia'
  },
  {
    id: 'griferia-color-2',
    title: 'Ex plomero crea escuela de oficios para jóvenes en situación vulnerable',
    excerpt: 'José "El Plomero" González enseña el oficio de la plomería a jóvenes de barrios populares.',
    content: 'José González, ex plomero de 50 años, ha creado una escuela de oficios en La Matanza donde enseña plomería y grifería a jóvenes en situación vulnerable. Su proyecto ya ha formado a más de 200 jóvenes que hoy tienen trabajo estable.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Educación y Trabajo',
    publishedDate: '2024-01-31',
    author: 'Diego Morales',
    tags: ['educación', 'oficios', 'inclusión social'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.educacionytrabajo.com/jose-plomero-escuela-oficios-jovenes-vulnerables'
  },
  {
    id: 'griferia-color-3',
    title: 'Famosa actriz argentina invierte en empresa de grifería sustentable',
    excerpt: 'La actriz Mercedes Morán apuesta por grifería eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Mercedes Morán ha invertido en una empresa de grifería sustentable. Su marca "Agua Verde" se especializa en productos que reducen el consumo de agua y utilizan materiales reciclados.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'griferia',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-02-02',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'grifería sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/mercedes-moran-invierte-griferia-sustentable'
  },

  // ===== FERRETERÍA =====
  // Noticias técnicas - Ferretería
  {
    id: 'ferreteria-tecnica-1',
    title: 'Innovaciones en herramientas inteligentes para el sector ferretero',
    excerpt: 'Empresas argentinas implementan herramientas con sensores y conectividad IoT.',
    content: 'La industria ferretera argentina está adoptando herramientas inteligentes que incluyen sensores de torque, conectividad Bluetooth y aplicaciones móviles. Estas innovaciones permiten mayor precisión, seguimiento de uso y mantenimiento predictivo.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Ferretería Inteligente',
    publishedDate: '2024-02-03',
    author: 'Ing. Roberto Silva',
    tags: ['herramientas inteligentes', 'IoT', 'sensores'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.ferreteriainteligente.com.ar/innovaciones-herramientas-inteligentes-sector-ferretero'
  },
  {
    id: 'ferreteria-tecnica-2',
    title: 'Desarrollo de materiales compuestos para herramientas de alta durabilidad',
    excerpt: 'Investigadores argentinos crean nuevos materiales para herramientas más resistentes.',
    content: 'Científicos del INTI están desarrollando nuevos materiales compuestos para herramientas que aumentan significativamente su durabilidad. Estos materiales incluyen fibras de carbono, cerámicas avanzadas y polímeros de alta resistencia.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Materiales Avanzados',
    publishedDate: '2024-02-05',
    author: 'Dr. Ana Martínez',
    tags: ['materiales compuestos', 'investigación', 'durabilidad'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.materialesavanzados.com.ar/desarrollo-materiales-compuestos-herramientas-alta-durabilidad'
  },
  {
    id: 'ferreteria-tecnica-3',
    title: 'Implementación de sistemas de gestión de inventario automatizado',
    excerpt: 'Ferreterías argentinas adoptan tecnología RFID para optimizar el control de stock.',
    content: 'Las ferreterías argentinas están implementando sistemas de gestión de inventario automatizado con tecnología RFID. Estos sistemas permiten control de stock en tiempo real, reducción de pérdidas y optimización de la cadena de suministro.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Gestión Ferretera',
    publishedDate: '2024-02-07',
    author: 'Carlos Mendoza',
    tags: ['RFID', 'inventario', 'automatización'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.gestionferretera.com.ar/implementacion-sistemas-gestion-inventario-automatizado'
  },
  // Noticias de color - Ferretería
  {
    id: 'ferreteria-color-1',
    title: 'Ferretero argentino gana premio internacional de innovación comercial',
    excerpt: 'Carlos "El Ferretero" Rodríguez recibió el "Retail Innovation Award" en España.',
    content: 'Carlos Rodríguez, ferretero de 45 años de Rosario, recibió el prestigioso "Retail Innovation Award" en la Feria de Comercio de Madrid. Su ferretería "Herramientas del Futuro" es reconocida por su innovador sistema de atención al cliente.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Comercio Argentino',
    publishedDate: '2024-02-04',
    author: 'Laura Fernández',
    tags: ['premios', 'innovación comercial', 'ferretería'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.comercioargentino.com/carlos-ferretero-premio-retail-innovation-espana'
  },
  {
    id: 'ferreteria-color-2',
    title: 'Ex ferretero crea app para conectar profesionales con herramientas',
    excerpt: 'Miguel "El Herramientas" López desarrolla plataforma digital para alquiler de herramientas.',
    content: 'Miguel López, ex ferretero de 38 años, ha creado una aplicación móvil que conecta profesionales con herramientas disponibles para alquiler. Su plataforma "Herramientas Compartidas" ya tiene más de 10,000 usuarios registrados.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Tecnología y Emprendimiento',
    publishedDate: '2024-02-06',
    author: 'Diego Morales',
    tags: ['app', 'emprendimiento', 'economía colaborativa'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.tecnologiayemprendimiento.com/miguel-herramientas-app-alquiler-herramientas'
  },
  {
    id: 'ferreteria-color-3',
    title: 'Famosa actriz argentina invierte en cadena de ferreterías sustentables',
    excerpt: 'La actriz Soledad Villamil apuesta por ferreterías eco-friendly en Buenos Aires.',
    content: 'La reconocida actriz argentina Soledad Villamil ha invertido en una cadena de ferreterías sustentables. Su marca "Ferretería Verde" se especializa en herramientas y materiales eco-friendly, promoviendo la construcción sustentable.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'ferreteria',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-02-08',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'ferretería sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/soledad-villamil-invierte-ferreterias-sustentables'
  },

  // ===== ABERTURAS =====
  // Noticias técnicas - Aberturas
  {
    id: 'aberturas-tecnica-1',
    title: 'Innovaciones en aberturas inteligentes para edificios argentinos',
    excerpt: 'Empresas argentinas implementan sistemas de aberturas automatizadas con sensores.',
    content: 'La industria de las aberturas en Argentina está adoptando tecnologías inteligentes que incluyen sensores de movimiento, control automático de temperatura y sistemas de seguridad integrados. Estas innovaciones permiten mayor eficiencia energética y confort.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Aberturas Inteligentes',
    publishedDate: '2024-02-09',
    author: 'Ing. Roberto Silva',
    tags: ['aberturas inteligentes', 'automatización', 'eficiencia energética'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.aberturasinteligentes.com.ar/innovaciones-aberturas-inteligentes-edificios-argentinos'
  },
  {
    id: 'aberturas-tecnica-2',
    title: 'Desarrollo de materiales compuestos para aberturas de alta eficiencia',
    excerpt: 'Investigadores argentinos crean nuevos materiales para aberturas más eficientes.',
    content: 'Científicos del INTI están desarrollando nuevos materiales compuestos para aberturas que mejoran significativamente la eficiencia energética. Estos materiales incluyen perfiles de PVC reforzado, vidrios de baja emisividad y sellos térmicos avanzados.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Materiales Avanzados',
    publishedDate: '2024-02-11',
    author: 'Dr. Ana Martínez',
    tags: ['materiales compuestos', 'eficiencia energética', 'investigación'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.materialesavanzados.com.ar/desarrollo-materiales-compuestos-aberturas-alta-eficiencia'
  },
  {
    id: 'aberturas-tecnica-3',
    title: 'Implementación de estándares de eficiencia energética en aberturas',
    excerpt: 'Nuevas normativas argentinas establecen estándares de eficiencia para aberturas residenciales.',
    content: 'El gobierno argentino está implementando nuevas normativas que establecen estándares de eficiencia energética para aberturas residenciales. Estas regulaciones promueven el uso de tecnologías que reducen el consumo energético sin comprometer la funcionalidad.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Normativas Argentinas',
    publishedDate: '2024-02-13',
    author: 'Carlos Mendoza',
    tags: ['eficiencia energética', 'normativas', 'sustentabilidad'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.normativasargentinas.com/implementacion-estandares-eficiencia-energetica-aberturas'
  },
  // Noticias de color - Aberturas
  {
    id: 'aberturas-color-1',
    title: 'Diseñador argentino gana premio internacional de diseño de aberturas',
    excerpt: 'Martín "El Aberturero" López recibió el "Window Design Award" en Alemania.',
    content: 'Martín López, diseñador argentino especializado en aberturas, recibió el prestigioso "Window Design Award" en la Feria de Hannover. Su colección "Ventanas del Futuro" combina diseño moderno con máxima eficiencia energética.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Diseño Argentino',
    publishedDate: '2024-02-10',
    author: 'Laura Fernández',
    tags: ['diseño', 'premios', 'aberturas sustentables'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.disenoargentino.com/martin-aberturero-premio-window-design-alemania'
  },
  {
    id: 'aberturas-color-2',
    title: 'Ex carpintero crea taller de aberturas para personas con discapacidad',
    excerpt: 'José "El Carpintero" González adapta aberturas para mejorar la accesibilidad.',
    content: 'José González, ex carpintero de 52 años, ha creado un taller especializado en aberturas adaptadas para personas con discapacidad. Sus diseños incluyen puertas automáticas, ventanas de fácil apertura y sistemas de control remoto.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Inclusión y Diseño',
    publishedDate: '2024-02-12',
    author: 'Diego Morales',
    tags: ['inclusión', 'aberturas adaptadas', 'accesibilidad'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.inclusionydiseno.com/jose-carpintero-aberturas-discapacidad'
  },
  {
    id: 'aberturas-color-3',
    title: 'Famosa actriz argentina invierte en empresa de aberturas sustentables',
    excerpt: 'La actriz Érica Rivas apuesta por aberturas eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Érica Rivas ha invertido en una empresa de aberturas sustentables. Su marca "Aberturas Verdes" se especializa en productos que maximizan la eficiencia energética y utilizan materiales reciclados.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'aberturas',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-02-14',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'aberturas sustentables'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/erica-rivas-invierte-aberturas-sustentables'
  },

  // ===== MAQUINARIA =====
  // Noticias técnicas - Maquinaria
  {
    id: 'maquinaria-tecnica-1',
    title: 'Innovaciones en maquinaria inteligente para la construcción argentina',
    excerpt: 'Empresas argentinas implementan maquinaria con sistemas de control autónomo y IoT.',
    content: 'La industria de la maquinaria en Argentina está adoptando tecnologías inteligentes que incluyen sistemas de control autónomo, sensores IoT y telemetría avanzada. Estas innovaciones permiten mayor eficiencia, seguridad y reducción de costos operativos.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Maquinaria Inteligente',
    publishedDate: '2024-02-15',
    author: 'Ing. Roberto Silva',
    tags: ['maquinaria inteligente', 'automatización', 'IoT'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.maquinariainteligente.com.ar/innovaciones-maquinaria-inteligente-construccion-argentina'
  },
  {
    id: 'maquinaria-tecnica-2',
    title: 'Desarrollo de motores híbridos para maquinaria de construcción',
    excerpt: 'Investigadores argentinos crean motores híbridos para reducir el consumo de combustible.',
    content: 'Científicos del INTI están desarrollando motores híbridos para maquinaria de construcción que combinan combustión interna con sistemas eléctricos. Estos motores reducen significativamente el consumo de combustible y las emisiones contaminantes.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Motores Avanzados',
    publishedDate: '2024-02-17',
    author: 'Dr. Ana Martínez',
    tags: ['motores híbridos', 'eficiencia', 'reducción emisiones'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.motoresavanzados.com.ar/desarrollo-motores-hibridos-maquinaria-construccion'
  },
  {
    id: 'maquinaria-tecnica-3',
    title: 'Implementación de sistemas de mantenimiento predictivo en maquinaria',
    excerpt: 'Empresas argentinas adoptan tecnología de mantenimiento predictivo para optimizar operaciones.',
    content: 'Las empresas de maquinaria argentinas están implementando sistemas de mantenimiento predictivo que utilizan sensores y análisis de datos para anticipar fallas. Estos sistemas reducen tiempos de inactividad y costos de mantenimiento.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Mantenimiento Avanzado',
    publishedDate: '2024-02-19',
    author: 'Carlos Mendoza',
    tags: ['mantenimiento predictivo', 'sensores', 'optimización'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.mantenimientoavanzado.com.ar/implementacion-sistemas-mantenimiento-predictivo-maquinaria'
  },
  // Noticias de color - Maquinaria
  {
    id: 'maquinaria-color-1',
    title: 'Operador argentino gana campeonato mundial de operación de maquinaria',
    excerpt: 'Carlos "El Operador" Rodríguez recibió el "World Machinery Operator Award" en Japón.',
    content: 'Carlos Rodríguez, operador de maquinaria de 35 años de Córdoba, recibió el prestigioso "World Machinery Operator Award" en el Campeonato Mundial de Operadores en Tokio. Su precisión y eficiencia en el manejo de excavadoras lo llevaron a la victoria.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Operadores Argentinos',
    publishedDate: '2024-02-16',
    author: 'Laura Fernández',
    tags: ['campeonato', 'operadores', 'maquinaria'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.operadoresargentinos.com/carlos-operador-campeonato-mundial-japon'
  },
  {
    id: 'maquinaria-color-2',
    title: 'Ex operador crea escuela de manejo de maquinaria para jóvenes',
    excerpt: 'Miguel "El Maquinista" López enseña técnicas de operación a jóvenes de barrios populares.',
    content: 'Miguel López, ex operador de maquinaria de 48 años, ha creado una escuela especializada en el manejo de maquinaria pesada en La Matanza. Su proyecto ya ha formado a más de 150 jóvenes que hoy trabajan en la construcción.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Educación y Trabajo',
    publishedDate: '2024-02-18',
    author: 'Diego Morales',
    tags: ['educación', 'oficios', 'inclusión social'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.educacionytrabajo.com/miguel-maquinista-escuela-manejo-maquinaria-jovenes'
  },
  {
    id: 'maquinaria-color-3',
    title: 'Famosa actriz argentina invierte en empresa de maquinaria sustentable',
    excerpt: 'La actriz Dolores Fonzi apuesta por maquinaria eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Dolores Fonzi ha invertido en una empresa de maquinaria sustentable. Su marca "Maquinaria Verde" se especializa en equipos eléctricos y híbridos que reducen el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'maquinaria',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-02-20',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'maquinaria sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/dolores-fonzi-invierte-maquinaria-sustentable'
  },

  // ===== HERRAMIENTAS =====
  // Noticias técnicas - Herramientas
  {
    id: 'herramientas-tecnica-1',
    title: 'Innovaciones en herramientas eléctricas inteligentes para profesionales argentinos',
    excerpt: 'Empresas argentinas implementan herramientas con conectividad y control digital.',
    content: 'La industria de las herramientas en Argentina está adoptando tecnologías inteligentes que incluyen conectividad Bluetooth, control de torque digital y aplicaciones móviles. Estas innovaciones permiten mayor precisión y seguimiento de uso.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Herramientas Inteligentes',
    publishedDate: '2024-02-21',
    author: 'Ing. Roberto Silva',
    tags: ['herramientas inteligentes', 'conectividad', 'control digital'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.herramientasinteligentes.com.ar/innovaciones-herramientas-electricas-inteligentes-profesionales-argentinos'
  },
  {
    id: 'herramientas-tecnica-2',
    title: 'Desarrollo de baterías de litio de alta duración para herramientas',
    excerpt: 'Investigadores argentinos crean baterías más eficientes para herramientas eléctricas.',
    content: 'Científicos del INTI están desarrollando baterías de litio de alta duración para herramientas eléctricas. Estas baterías ofrecen mayor autonomía, menor tiempo de carga y mayor vida útil, revolucionando el sector de herramientas portátiles.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Baterías Avanzadas',
    publishedDate: '2024-02-23',
    author: 'Dr. Ana Martínez',
    tags: ['baterías de litio', 'autonomía', 'investigación'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.bateriasavanzadas.com.ar/desarrollo-baterias-litio-alta-duracion-herramientas'
  },
  {
    id: 'herramientas-tecnica-3',
    title: 'Implementación de sistemas de seguridad avanzados en herramientas',
    excerpt: 'Empresas argentinas adoptan tecnologías de seguridad para reducir accidentes laborales.',
    content: 'Las empresas de herramientas argentinas están implementando sistemas de seguridad avanzados que incluyen frenos automáticos, sensores de proximidad y protección contra sobrecarga. Estos sistemas reducen significativamente los accidentes laborales.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Seguridad Industrial',
    publishedDate: '2024-02-25',
    author: 'Carlos Mendoza',
    tags: ['seguridad', 'protección', 'prevención'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.seguridadindustrial.com.ar/implementacion-sistemas-seguridad-avanzados-herramientas'
  },
  // Noticias de color - Herramientas
  {
    id: 'herramientas-color-1',
    title: 'Técnico argentino gana competencia internacional de reparación de herramientas',
    excerpt: 'Martín "El Técnico" López recibió el "Tool Repair Championship" en Estados Unidos.',
    content: 'Martín López, técnico de herramientas de 42 años de Rosario, recibió el prestigioso "Tool Repair Championship" en la competencia internacional de técnicos en Chicago. Su habilidad para diagnosticar y reparar herramientas complejas lo llevó a la victoria.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Técnicos Argentinos',
    publishedDate: '2024-02-22',
    author: 'Laura Fernández',
    tags: ['competencia', 'técnicos', 'reparación'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.tecnicosargentinos.com/martin-tecnico-competencia-internacional-estados-unidos'
  },
  {
    id: 'herramientas-color-2',
    title: 'Ex técnico crea taller de reparación de herramientas para jóvenes',
    excerpt: 'Carlos "El Reparador" González enseña técnicas de reparación a jóvenes de barrios populares.',
    content: 'Carlos González, ex técnico de herramientas de 50 años, ha creado un taller especializado en reparación de herramientas en La Boca. Su proyecto ya ha formado a más de 80 jóvenes que hoy trabajan en talleres mecánicos.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Educación y Trabajo',
    publishedDate: '2024-02-24',
    author: 'Diego Morales',
    tags: ['educación', 'oficios', 'inclusión social'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.educacionytrabajo.com/carlos-reparador-taller-reparacion-herramientas-jovenes'
  },
  {
    id: 'herramientas-color-3',
    title: 'Famosa actriz argentina invierte en empresa de herramientas sustentables',
    excerpt: 'La actriz Valeria Bertuccelli apuesta por herramientas eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Valeria Bertuccelli ha invertido en una empresa de herramientas sustentables. Su marca "Herramientas Verdes" se especializa en productos que utilizan materiales reciclados y energías renovables.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'herramientas',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-02-26',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'herramientas sustentables'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/valeria-bertuccelli-invierte-herramientas-sustentables'
  },

  // ===== ARQUITECTOS =====
  // Noticias técnicas - Arquitectos
  {
    id: 'arquitectos-tecnica-1',
    title: 'Nuevas tecnologías en construcción sustentable en Argentina',
    excerpt: 'El sector de la construcción en Argentina adopta nuevas tecnologías verdes para reducir el impacto ambiental.',
    content: 'La industria de la construcción en Argentina está experimentando una revolución tecnológica con la adopción de materiales sustentables y técnicas de construcción eco-friendly. Empresas líderes del sector están implementando sistemas de energía renovable y materiales reciclados en sus proyectos.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Construcción Hoy',
    publishedDate: '2024-01-15',
    author: 'María González',
    tags: ['construcción', 'sustentabilidad', 'tecnología'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.construccionhoy.com.ar/nuevas-tecnologias-construccion-sustentable-argentina'
  },
  {
    id: 'arquitectos-tecnica-2',
    title: 'Implementación de BIM en proyectos de infraestructura argentinos',
    excerpt: 'El Building Information Modeling revoluciona la planificación y ejecución de obras públicas en el país.',
    content: 'El Ministerio de Obras Públicas de Argentina está implementando el sistema BIM en todos los proyectos de infraestructura nacional. Esta tecnología permite una mejor coordinación entre arquitectos, ingenieros y constructores, reduciendo errores y costos.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Infraestructura Argentina',
    publishedDate: '2024-01-18',
    author: 'Carlos Ruiz',
    tags: ['BIM', 'infraestructura', 'tecnología'],
    isTechnical: true,
    readTime: 6,
    url: 'https://www.infraestructuraargentina.com.ar/implementacion-bim-proyectos-infraestructura'
  },
  {
    id: 'arquitectos-tecnica-3',
    title: 'Avances en construcción modular en Buenos Aires',
    excerpt: 'Empresas constructoras adoptan sistemas modulares para acelerar la entrega de viviendas sociales.',
    content: 'La construcción modular está ganando terreno en Argentina, especialmente en proyectos de vivienda social. Empresas como Techint y Sideco están implementando fábricas de módulos que permiten construir viviendas completas en tiempo récord.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Construcción Modular',
    publishedDate: '2024-01-20',
    author: 'Ana Martínez',
    tags: ['construcción modular', 'vivienda social', 'eficiencia'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.construccionmodular.com.ar/avances-construccion-modular-buenos-aires'
  },
  // Noticias de color - Arquitectos
  {
    id: 'arquitectos-color-1',
    title: 'Arquitecto argentino gana premio internacional de diseño sustentable',
    excerpt: 'El arquitecto porteño Martín Gómez recibió el premio "Green Building of the Year" por su proyecto en Palermo.',
    content: 'Martín Gómez, arquitecto argentino de 35 años, recibió el prestigioso premio "Green Building of the Year" en la conferencia internacional de arquitectura sustentable. Su proyecto, un edificio residencial en Palermo, combina diseño moderno con tecnologías eco-friendly.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Arquitectura Argentina',
    publishedDate: '2024-01-16',
    author: 'Laura Fernández',
    tags: ['arquitectura', 'premios', 'diseño sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.arquitecturaargentina.com/arquitecto-argentino-premio-internacional-diseno-sustentable'
  },
  {
    id: 'arquitectos-color-2',
    title: 'Famosa actriz argentina invierte en desarrollo inmobiliario sustentable',
    excerpt: 'La actriz Julieta Díaz anunció su participación en un proyecto de viviendas ecológicas en Tigre.',
    content: 'La reconocida actriz argentina Julieta Díaz anunció su incursión en el mundo inmobiliario con un proyecto de viviendas sustentables en Tigre. El desarrollo incluirá 50 casas con paneles solares, sistemas de reciclaje de agua y espacios verdes.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Espectáculos y Negocios',
    publishedDate: '2024-01-19',
    author: 'María López',
    tags: ['celebridades', 'inversión', 'viviendas sustentables'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.espectaculosynegocios.com/julieta-diaz-invierte-desarrollo-inmobiliario-sustentable'
  },
  {
    id: 'arquitectos-color-3',
    title: 'Ex futbolista construye barrio deportivo en su ciudad natal',
    excerpt: 'El ex jugador de Boca Juniors, Martín Palermo, desarrolla un complejo deportivo en La Plata.',
    content: 'Martín Palermo, legendario delantero de Boca Juniors, está construyendo un complejo deportivo en su ciudad natal, La Plata. El proyecto incluye canchas de fútbol, piscinas, gimnasio y un centro de entrenamiento para jóvenes talentos.',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop&crop=center',
    category: 'arquitectos',
    source: 'Deportes y Construcción',
    publishedDate: '2024-01-21',
    author: 'Diego Morales',
    tags: ['fútbol', 'deportes', 'complejo deportivo'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.deportesyconstruccion.com/martin-palermo-construye-barrio-deportivo-la-plata'
  },

  // ===== M.M DE OBRA =====
  // Noticias técnicas - M.M de Obra
  {
    id: 'mm-obra-tecnica-1',
    title: 'Innovaciones en gestión de proyectos de construcción para maestros mayor de obra',
    excerpt: 'Maestros mayor de obra argentinos adoptan tecnologías digitales para optimizar la gestión de proyectos.',
    content: 'Los maestros mayor de obra en Argentina están adoptando tecnologías digitales que incluyen software de gestión de proyectos, aplicaciones móviles para control de obra y sistemas de comunicación en tiempo real. Estas herramientas mejoran la eficiencia y reducen errores.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Gestión de Obra',
    publishedDate: '2024-02-27',
    author: 'Ing. Roberto Silva',
    tags: ['gestión de proyectos', 'tecnología digital', 'control de obra'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.gestiondeobra.com.ar/innovaciones-gestion-proyectos-construccion-maestros-mayor-obra'
  },
  {
    id: 'mm-obra-tecnica-2',
    title: 'Implementación de sistemas de seguridad avanzados en obras argentinas',
    excerpt: 'Maestros mayor de obra implementan nuevas tecnologías de seguridad para proteger a los trabajadores.',
    content: 'Los maestros mayor de obra argentinos están implementando sistemas de seguridad avanzados que incluyen sensores de movimiento, cascos inteligentes con GPS y aplicaciones de monitoreo de seguridad. Estas tecnologías reducen significativamente los accidentes laborales.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Seguridad en Obra',
    publishedDate: '2024-02-29',
    author: 'Dr. Ana Martínez',
    tags: ['seguridad', 'protección', 'monitoreo'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.seguridadenobra.com.ar/implementacion-sistemas-seguridad-avanzados-obras-argentinas'
  },
  {
    id: 'mm-obra-tecnica-3',
    title: 'Desarrollo de técnicas de construcción sustentable para maestros mayor de obra',
    excerpt: 'Investigadores argentinos crean nuevas técnicas de construcción eco-friendly para maestros mayor de obra.',
    content: 'Científicos del INTI están desarrollando nuevas técnicas de construcción sustentable específicamente diseñadas para maestros mayor de obra. Estas técnicas incluyen sistemas de aislamiento térmico avanzado y materiales reciclados que reducen el impacto ambiental.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Construcción Sustentable',
    publishedDate: '2024-03-02',
    author: 'Carlos Mendoza',
    tags: ['construcción sustentable', 'técnicas eco-friendly', 'investigación'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.construccionsustentable.com.ar/desarrollo-tecnicas-construccion-sustentable-maestros-mayor-obra'
  },
  // Noticias de color - M.M de Obra
  {
    id: 'mm-obra-color-1',
    title: 'Maestro mayor de obra argentino gana premio internacional de gestión de proyectos',
    excerpt: 'Carlos "El Maestro" Rodríguez recibió el "Project Management Excellence Award" en España.',
    content: 'Carlos Rodríguez, maestro mayor de obra de 45 años de Córdoba, recibió el prestigioso "Project Management Excellence Award" en la conferencia internacional de construcción en Madrid. Su proyecto de viviendas sociales fue reconocido por su eficiencia y calidad.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Maestros Argentinos',
    publishedDate: '2024-02-28',
    author: 'Laura Fernández',
    tags: ['premios', 'gestión de proyectos', 'viviendas sociales'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.maestrosargentinos.com/carlos-maestro-premio-project-management-espana'
  },
  {
    id: 'mm-obra-color-2',
    title: 'Ex maestro mayor de obra crea escuela de oficios para jóvenes',
    excerpt: 'Miguel "El Constructor" López enseña técnicas de construcción a jóvenes de barrios populares.',
    content: 'Miguel López, ex maestro mayor de obra de 55 años, ha creado una escuela de oficios en La Matanza donde enseña técnicas de construcción a jóvenes de barrios populares. Su proyecto ya ha formado a más de 200 jóvenes que hoy trabajan en la construcción.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Educación y Trabajo',
    publishedDate: '2024-03-01',
    author: 'Diego Morales',
    tags: ['educación', 'oficios', 'inclusión social'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.educacionytrabajo.com/miguel-constructor-escuela-oficios-jovenes'
  },
  {
    id: 'mm-obra-color-3',
    title: 'Famosa actriz argentina invierte en empresa de construcción sustentable',
    excerpt: 'La actriz Paola Barrientos apuesta por construcción eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Paola Barrientos ha invertido en una empresa de construcción sustentable. Su marca "Construcción Verde" se especializa en proyectos que utilizan materiales eco-friendly y técnicas de construcción sustentable.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'mm-obra',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-03-03',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'construcción sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/paola-barrientos-invierte-construccion-sustentable'
  },

  // ===== GESTORES =====
  // Noticias técnicas - Gestores
  {
    id: 'gestores-tecnica-1',
    title: 'Innovaciones en gestión digital de trámites para el sector de la construcción',
    excerpt: 'Gestores argentinos adoptan plataformas digitales para optimizar la gestión de trámites.',
    content: 'Los gestores argentinos están adoptando plataformas digitales que incluyen sistemas de gestión de trámites online, aplicaciones móviles para seguimiento de expedientes y automatización de procesos. Estas tecnologías reducen tiempos de gestión y mejoran la eficiencia.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'Gestión Digital',
    publishedDate: '2024-03-04',
    author: 'Ing. Roberto Silva',
    tags: ['gestión digital', 'trámites online', 'automatización'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.gestiondigital.com.ar/innovaciones-gestion-digital-tramites-sector-construccion'
  },
  {
    id: 'gestores-tecnica-2',
    title: 'Implementación de blockchain en la gestión de certificados y permisos',
    excerpt: 'Gestores argentinos implementan tecnología blockchain para garantizar la autenticidad de documentos.',
    content: 'Los gestores argentinos están implementando tecnología blockchain para la gestión de certificados y permisos. Esta tecnología garantiza la autenticidad de los documentos, reduce la falsificación y mejora la transparencia en los procesos de gestión.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'Blockchain y Gestión',
    publishedDate: '2024-03-06',
    author: 'Dr. Ana Martínez',
    tags: ['blockchain', 'certificados', 'transparencia'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.blockchainygestion.com.ar/implementacion-blockchain-gestion-certificados-permisos'
  },
  {
    id: 'gestores-tecnica-3',
    title: 'Desarrollo de sistemas de inteligencia artificial para optimización de trámites',
    excerpt: 'Investigadores argentinos crean sistemas de IA para automatizar procesos de gestión.',
    content: 'Científicos argentinos están desarrollando sistemas de inteligencia artificial específicamente diseñados para optimizar procesos de gestión. Estos sistemas incluyen chatbots para atención al cliente y algoritmos para la clasificación automática de documentos.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'IA y Gestión',
    publishedDate: '2024-03-08',
    author: 'Carlos Mendoza',
    tags: ['inteligencia artificial', 'automatización', 'chatbots'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.iaygestion.com.ar/desarrollo-sistemas-inteligencia-artificial-optimizacion-tramites'
  },
  // Noticias de color - Gestores
  {
    id: 'gestores-color-1',
    title: 'Gestor argentino gana premio internacional de innovación en gestión pública',
    excerpt: 'Martín "El Gestor" López recibió el "Public Management Innovation Award" en Canadá.',
    content: 'Martín López, gestor argentino de 40 años de Buenos Aires, recibió el prestigioso "Public Management Innovation Award" en la conferencia internacional de gestión pública en Toronto. Su sistema de gestión digital fue reconocido por su eficiencia y transparencia.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'Gestores Argentinos',
    publishedDate: '2024-03-05',
    author: 'Laura Fernández',
    tags: ['premios', 'innovación', 'gestión pública'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.gestoresargentinos.com/martin-gestor-premio-public-management-canada'
  },
  {
    id: 'gestores-color-2',
    title: 'Ex gestor crea plataforma digital para ayudar a emprendedores',
    excerpt: 'Carlos "El Digital" González desarrolla app para simplificar trámites para pequeños empresarios.',
    content: 'Carlos González, ex gestor de 45 años, ha creado una plataforma digital que ayuda a emprendedores a simplificar sus trámites. Su aplicación "TramitesFácil" ya ha ayudado a más de 5,000 pequeños empresarios a gestionar sus documentos de manera eficiente.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'Tecnología y Emprendimiento',
    publishedDate: '2024-03-07',
    author: 'Diego Morales',
    tags: ['plataforma digital', 'emprendedores', 'simplificación'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.tecnologiayemprendimiento.com/carlos-digital-plataforma-tramites-emprendedores'
  },
  {
    id: 'gestores-color-3',
    title: 'Famosa actriz argentina invierte en empresa de gestión digital',
    excerpt: 'La actriz Ailín Salas apuesta por gestión digital en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Ailín Salas ha invertido en una empresa de gestión digital. Su marca "GestiónFácil" se especializa en plataformas digitales que simplifican trámites para empresas y particulares.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'gestores',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-03-09',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'gestión digital'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/ailin-salas-invierte-gestion-digital'
  },

  // ===== CONSTRUCTORAS =====
  // Noticias técnicas - Constructoras
  {
    id: 'constructoras-tecnica-1',
    title: 'Innovaciones en construcción industrializada para constructoras argentinas',
    excerpt: 'Constructoras argentinas adoptan sistemas de construcción industrializada para mejorar la eficiencia.',
    content: 'Las constructoras argentinas están adoptando sistemas de construcción industrializada que incluyen prefabricación de elementos, construcción modular y sistemas de ensamblaje en seco. Estas tecnologías permiten reducir tiempos de construcción y costos.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Construcción Industrializada',
    publishedDate: '2024-03-10',
    author: 'Ing. Roberto Silva',
    tags: ['construcción industrializada', 'prefabricación', 'eficiencia'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.construccionindustrializada.com.ar/innovaciones-construccion-industrializada-constructoras-argentinas'
  },
  {
    id: 'constructoras-tecnica-2',
    title: 'Implementación de sistemas de gestión de calidad total en constructoras',
    excerpt: 'Constructoras argentinas implementan sistemas de calidad total para garantizar la excelencia.',
    content: 'Las constructoras argentinas están implementando sistemas de gestión de calidad total que incluyen control de calidad en cada etapa del proceso constructivo, certificaciones ISO y sistemas de mejora continua. Estos sistemas garantizan la excelencia en los proyectos.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Calidad Total',
    publishedDate: '2024-03-12',
    author: 'Dr. Ana Martínez',
    tags: ['gestión de calidad', 'certificaciones ISO', 'excelencia'],
    isTechnical: true,
    readTime: 5,
    url: 'https://www.calidadtotal.com.ar/implementacion-sistemas-gestion-calidad-total-constructoras'
  },
  {
    id: 'constructoras-tecnica-3',
    title: 'Desarrollo de proyectos de construcción sustentable para constructoras',
    excerpt: 'Constructoras argentinas desarrollan proyectos con certificaciones LEED y BREEAM.',
    content: 'Las constructoras argentinas están desarrollando proyectos de construcción sustentable que incluyen certificaciones LEED y BREEAM, sistemas de energía renovable y materiales eco-friendly. Estos proyectos reducen el impacto ambiental y mejoran la eficiencia energética.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Construcción Sustentable',
    publishedDate: '2024-03-14',
    author: 'Carlos Mendoza',
    tags: ['construcción sustentable', 'certificaciones LEED', 'energía renovable'],
    isTechnical: true,
    readTime: 4,
    url: 'https://www.construccionsustentable.com.ar/desarrollo-proyectos-construccion-sustentable-constructoras'
  },
  // Noticias de color - Constructoras
  {
    id: 'constructoras-color-1',
    title: 'Constructora argentina gana premio internacional de excelencia en construcción',
    excerpt: 'Constructora "Edificios del Sur" recibió el "Construction Excellence Award" en Alemania.',
    content: 'La constructora argentina "Edificios del Sur" recibió el prestigioso "Construction Excellence Award" en la feria internacional de construcción en Berlín. Su proyecto de torres residenciales sustentables fue reconocido por su innovación y calidad.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Constructoras Argentinas',
    publishedDate: '2024-03-11',
    author: 'Laura Fernández',
    tags: ['premios', 'excelencia', 'construcción sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.constructorasargentinas.com/edificios-del-sur-premio-construction-excellence-alemania'
  },
  {
    id: 'constructoras-color-2',
    title: 'Ex director de constructora crea fundación para viviendas sociales',
    excerpt: 'Miguel "El Constructor" López desarrolla proyectos de viviendas sociales para familias vulnerables.',
    content: 'Miguel López, ex director de una constructora de 50 años, ha creado una fundación que desarrolla proyectos de viviendas sociales para familias vulnerables. Su proyecto "Hogares para Todos" ya ha construido más de 500 viviendas en diferentes provincias.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Fundaciones Argentinas',
    publishedDate: '2024-03-13',
    author: 'Diego Morales',
    tags: ['fundación', 'viviendas sociales', 'inclusión'],
    isTechnical: false,
    readTime: 4,
    url: 'https://www.fundacionesargentinas.com/miguel-constructor-fundacion-viviendas-sociales'
  },
  {
    id: 'constructoras-color-3',
    title: 'Famosa actriz argentina invierte en constructora sustentable',
    excerpt: 'La actriz Griselda Siciliani apuesta por construcción eco-friendly en su nuevo emprendimiento.',
    content: 'La reconocida actriz argentina Griselda Siciliani ha invertido en una constructora sustentable. Su empresa "Construcción Verde Argentina" se especializa en proyectos residenciales y comerciales que utilizan tecnologías eco-friendly y materiales sustentables.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=250&fit=crop&crop=center',
    category: 'constructoras',
    source: 'Celebridades y Negocios',
    publishedDate: '2024-03-15',
    author: 'Sofía Rodríguez',
    tags: ['celebridades', 'emprendimiento', 'construcción sustentable'],
    isTechnical: false,
    readTime: 3,
    url: 'https://www.celebridadesynegocios.com/griselda-siciliani-invierte-constructora-sustentable'
  }
];
